import { supabase } from '../lib/supabase';

export async function signInWithEmailOtp(email) {
  const { error } = await supabase.auth.signInWithOtp({ email });
  if (error) throw error;
}

export async function signInWithEmailPassword(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function getSession() {
  const { data } = await supabase.auth.getSession();
  return data.session || null;
}

export function onAuthStateChange(callback) {
  const { data } = supabase.auth.onAuthStateChange((_event, session) => {
    callback(session);
  });
  return () => data.subscription.unsubscribe();
}

export async function getMyProfile() {
  const session = await getSession();
  if (!session?.user?.id) return null;
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', session.user.id)
    .maybeSingle(); // Use maybeSingle() instead of single() to handle empty result
  if (error) {
    console.error('getMyProfile error:', error);
    throw error;
  }
  return data;
}

export async function isAdmin() {
  try {
    const profile = await getMyProfile();
    return profile?.role === 'admin';
  } catch (err) {
    console.error('isAdmin error:', err);
    return false;
  }
}

export async function updateUserEmail(newEmail) {
  const { data, error } = await supabase.auth.updateUser({ email: newEmail });
  if (error) throw error;
  return data;
}

export async function updateUserPassword(newPassword) {
  const { data, error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) throw error;
  return data;
}


